/* Layout */
import AccessKeyManage from '@/views/information/accesskey/index';
import Basic from '@/views/information/basic/index';
import Integral from '@/views/information/integral/index';
import OpenMarket from '@/views/information/openmarket/index';
import Organization from '@/views/information/organization/index';
import RoleManage from '@/views/information/roleManage/index';
import Layout from '@/views/layout/Layout';

const enterpriseManageRouter = {
  path: '/manage/myapp',
  component: Layout,
  props: true,
  name: 'enterpriseManage',
  meta: {
    title: '企业管理',
    icon: 'enterprise-management',
    requireAuth: true
  },
  redirect: '/manage/management/basic',
  children: [
    {
      path: 'basic',
      name: 'basic',
      component: Basic,
      meta: {
        title: '基础设置',
        icon: 'infrastructure',
        requireAuth: true,
        perms: ['Enterprise.Update']
      },
      hidden: false
    },
    {
      path: 'integral',
      name: 'integral',
      component: Integral,
      meta: {
        title: '企业金额',
        icon: 'enterprise-integration',
        requireAuth: true,
        role: 'user',
        perms: ['EntPyament.List']
      },
      hidden: false
    },
    {
      path: 'organization',
      name: 'organization',
      component: Organization,
      meta: {
        title: '组织机构',
        icon: 'organization',
        perms: ['Enterprise.Organization.List'],
        requireAuth: true
      },
      hidden: false
    },
    {
      path: 'roles',
      name: 'adminRoleManage',
      component: RoleManage,
      meta: {
        title: '角色管理',
        perms: ['Enterprise.Role.List'],
        icon: 'role-management',
        requireAuth: true
      },
      hidden: false
    },
    {
      path: 'accesskeys',
      name: 'accesskeys',
      component: AccessKeyManage,
      meta: {
        title: 'AccessKey管理',
        perms: ['Enterprise.AccessKey.List'],
        icon: 'role-management',
        requireAuth: true
      },
      hidden: false
    },
    {
      path: 'openmarket',
      name: 'openmarket',
      component: OpenMarket,
      type: 'buyers',
      meta: {
        title: '申请开通商店',
        icon: 'apply-opening-shop',
        requireAuth: true,
        perms: ['Enterprise.PendingMarket.Create'],
        role: 'user'
      },
      hidden: false
    }
  ]
};
export default enterpriseManageRouter;



// WEBPACK FOOTER //
// ./src/router/modules/enterpriseManage.js